<template>
  <!-- <main-area> -->
  <div class="homePage">
    <div class="bannerBgc">
      <div class="carousel-container">
        <div class="carousel-slide">
          <img
            src="../../assets/image/lunbo/lunbo1.png"
            class="original-size-img"
          />
          <img
            src="../../assets/image/lunbo/beijing2.png"
            alt="轮播图2"
            class="original-size-img"
          />
          <img
            src="../../assets/image/lunbo/beijing3.png"
            alt="轮播图3"
            class="original-size-img"
          />
          <img
            src="../../assets/image/lunbo/lunbo2.png"
            alt="轮播图4"
            class="original-size-img"
          />
        </div>

        <!-- 文字内容（与图片一一对应） -->
        <div class="text-overlaydontai">
          <div class="xiaoguo1" :class="{ active: currentIndex === 0 }">
            <div class="biaoti1">信息与通信方案服务提供商</div>
            <div class="xichengwenzi">
              提供网络及网络安全基础架构规划架构设计、有线及无线网络和网络安全<br />全球化统一运维、统一通信网络全球化部署
            </div>
            <img src="@/assets/image/lunbo/dontaitu.png" class="right-image" />
          </div>
          <div class="xiaoguo2" :class="{ active: currentIndex === 1 }">
            <div class="biaoti1">诚信、务实、创新、进取</div>
            <div class="xichengwenzi">中华科技、创新有成，诚信立业</div>
          </div>
          <div class="xiaoguo3" :class="{ active: currentIndex === 2 }">
            <div class="biaoti1">领先的信息与通信解决方案提供商</div>
            <div class="xichengwenzi">
              广州鹏海专注于通信网络的集成、应用与服务，致力于为客户提供定制化的解决方案
            </div>
          </div>
          <div class="xiaoguo4" :class="{ active: currentIndex === 3 }">
            <div class="biaoti1">中华科技、创新有成，诚信立业</div>
            <div class="xichengwenzi">诚信、务实、创新、进取</div>
          </div>
        </div>

        <!-- 指示器 -->
        <div class="carousel-indicators">
          <span
            v-for="(_, index) in 4"
            :key="index"
            class="indicator"
            :class="{ active: currentIndex === index }"
            @click="goToSlide(index)"
          ></span>
        </div>
      </div>
    </div>

    <!-- 主要内容部分 -->
    <!-- 服务范围 -->
    <div class="announcement">
      <div class="fuwufangweu">
        <div class="biaoti">
          <h2 class="fangwei">服务范围</h2>
          <br />
          <p class="yingwen">
            Wi-Fi as a Service、Networks as a Service、NGN as a
            Service、Security as a Service
          </p>
          <br />
          <img src="../../assets/other/car.png" alt="" class="car" />
        </div>
      </div>

      <div class="product">
        <div class="title">公司动态</div>
        <br />
        <img src="@/assets/other/icons/gongsidontai.png" />
      </div>
      <br />
      <div class="liaojiebtn">
        <a href="#" class="anniubtn" @click.prevent="goToNews"> 了解详情 </a>
      </div>
      <br />
      <br />

      <!-- 服务优势部分 -->
      <div class="service">
        <div class="title">合作伙伴</div>
        <div class="service-info" style="margin-top: -5.5%">
          <div class="img2">
            <img src="@/assets/other/icons/LOGO.png" alt="" class="hzhb" />
          </div>
        </div>
      </div>

      <div class="liaojiebtn">
        <!-- <a href="#" class="anniubtn">
          了解详情
        </a> -->
      </div>
      <!-- <br /><br /><br /><br /><br /><br /> -->
    </div>
    <Footer :show="true" />
  </div>
  <!-- </main-area> -->
</template>
<!--  -->
<style>
/* 新增样式 */
.text-overlaydontai {
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  height: 100%;
  pointer-events: none;
}

.xiaoguo1,
.xiaoguo2,
.xiaoguo3,
.xiaoguo4 {
  /* 标题：最小 24px，最大 70px，中间按 5vw 动态缩放 */
  font-size: clamp(24px, 5vw, 70px);
  /* 保持原有行高逻辑，或改用相对单位 */
  line-height: 1.2;
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  opacity: 0;
  transition: opacity 0.5s;
  width: 70%;
}

.xiaoguo1.active,
.xiaoguo2.active,
.xiaoguo3.active,
.xiaoguo4.active {
  opacity: 1;
}

.right-image {
  position: absolute;
  left: 95%;
  object-fit: contain;
  top: 50%;
  transform: translateY(-50%);
  max-width: 583.56px;
  max-height: 541px;
  object-fit: contain;
}

.xiaoguo1,
.xiaoguo2,
.xiaoguo3,
.xiaoguo4 {
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 101.36px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.xichengwenzi {
  /* 描述：最小 16px，最大 26px，中间按 2vw 动态缩放 */
  font-size: clamp(16px, 2vw, 26px);
  line-height: 1.6;
  /* 移除<br>强制换行，让文本自动适配 */
  white-space: normal;
  font-size: 26px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
  z-index: 9999;
}

/* 轮播图容器 - 居中显示 */
.carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 根据图片高度自适应 */
}

/* 轮播图滑动区域 */
.carousel-slide {
  display: flex;
  transition: transform 0.5s ease;
  height: auto;
  /* 根据图片高度自适应 */
}

/* 保持图片原始尺寸 */
.original-size-img {
  width: 1440px;
  height: 588px;
  max-width: 100%;
  /* 防止图片超出屏幕宽度 */
  display: block;
  /* 移除图片底部间隙 */
  flex-shrink: 0;
  /* 防止图片被压缩 */
}

/* 指示器容器 */
.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* 指示器样式 */
.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background-color: #fff;
  width: 20px;
  border-radius: 5px;
}

.anniubtn:hover {
  background: rgba(218, 41, 28, 1);
  display: flex;
  color: white;
}

.anniubtn:active {
  transform: scale(0.98);
  /* 点击时轻微缩小 */
}

.anniubtn {
  white-space: nowrap;
  /* 禁止文字换行 */
  transition: all 0.3s ease;
  /* 平滑过渡动画 */
  text-decoration: none;
  background-color: white;
  text-align: center;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  width: 156px;
  height: 56px;
  opacity: 1;
  border-radius: 9px;
  color: rgba(218, 41, 28, 1);
  border: 1px solid rgba(218, 41, 28, 1);
  display: flex;
  padding: 10px 40px 10px 40px;
  font-size: 18px;
  letter-spacing: 0px;
  line-height: 32px;
}

.car {
  object-fit: contain;
  width: 1112px;
  height: 470px;
  opacity: 1;
  display: flex;
}

.biaoti {
  margin-top: 150px;
  height: 135px;
}

.fangwei {
  font-size: 44px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 55.5px;
  color: rgba(46, 49, 51, 1);
  text-align: center;
  vertical-align: top;
}

.yingwen {
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 32px;
  color: rgba(103, 106, 108, 1);
  text-align: center;
  vertical-align: top;
}

.fuwufangweu {
  width: 100%;
  height: 860px;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  background: url("../../assets/other/icons/beijinban.png");
  /*    padding: 20px 200px; */
  /* margin-top: 30px; */
}

.img2 {
  margin: 0 auto;
  width: 1440px;
  height: 100%;
}

.img2 img {
  width: 1240px;
  height: 522px;
  /* 保持比例 */
  object-fit: contain;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicator.active {
  background-color: #fff;
  width: 20px;
  border-radius: 5px;
}
</style>

<!--  -->
<script>
import MainArea from "@/components/MainArea";
import news from "./components/news.vue";
import { getNewsList } from "@/api/api.js";

export default {
  components: {
    MainArea,
    news,
  },
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      activeName: "LogoCanvas",
      carHeight: "400px",
      workList: [{}, {}, {}],
      hotList: [],
      timeline: [
        {
          id: "1",
          name: "第一届",
          t: "2005",
        },
        {
          id: "2",
          name: "第二届",
          t: "2022",
        },
        {
          id: "3",
          name: "第三届",
          t: "2022",
        },
        {
          id: "4",
          name: "第四届",
          t: "2022",
        },
        {
          id: "5",
          name: "第五届",
          t: "2022",
        },
        {
          id: "6",
          name: "第六届",
          t: "2022",
        },
        {
          id: "7",
          name: "第七届",
          t: "2022",
        },

        {
          id: "8",
          name: "第八届",
          t: "2022",
        },
        {
          id: "9",
          name: "第九届",
          t: "2022",
        },
        {
          id: "10",
          name: "第十届",
          t: "2022",
        },
        {
          id: "11",
          name: "第十一届",
          t: "2022",
        },
        {
          id: "12",
          name: "第十二届",
          t: "2022",
        },
        {
          id: "13",
          name: "第十三届",
          t: "2022",
        },
        {
          id: "14",
          name: "第十四届",
          t: "2022",
        },
        {
          id: "15",
          name: "第十五届",
          t: "2022",
        },
        {
          id: "16",
          name: "第十六届",
          t: "2022",
        },
        {
          id: "17",
          name: "第十七届",
          t: "2022",
        },
      ].reverse(),
      flexArr: [
        {
          title: "主赛道",
          img: require("@/assets/image/zhusaidao.png"),
        },
        {
          title: "港澳台创新设计对接赛",
          img: require("@/assets/image/duijie.png"),
        },
        {
          title: "企业设计命题专项赛",
          img: require("@/assets/image/zhuanti.png"),
        },
      ],
      judgesArr: [
        {
          name: "张三",
          url: require("@/assets/image/pingwei.png"),
          introduction:
            "他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三他是张三",
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四",
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五",
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六",
        },
        {
          name: "赵四",
          url: require("@/assets/image/goodbit.png"),
          introduction: "他是赵四",
        },
        {
          name: "王五",
          url: require("@/assets/image/zhuban2.png"),
          introduction: "他是王五",
        },
        {
          name: "李六",
          url: require("@/assets/image/yin.png"),
          introduction: "他是李六",
        },
      ],
      translateY: 0,
      activeIndex: 0,
      isActive1: true,
      isActive2: true,
      isActive3: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initCarousel();
      document.querySelector(".xiaoguo1").style.opacity = "1";
    });
  },
  methods: {
    goToNews() {
      this.$router.push("/workspace#news");
    },
    initCarousel() {
      const slide = document.querySelector(".carousel-slide");
      const slides = document.querySelectorAll(".original-size-img");
      const indicators = document.querySelectorAll(".indicator");

      // 调试检查
      if (!slide || slides.length === 0) {
        console.error("轮播图元素未找到");
        return;
      }

      // 确保图片加载完成
      Promise.all(
        Array.from(slides).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.addEventListener("load", resolve);
            img.addEventListener("error", resolve); // 即使失败也继续
          });
        })
      )
        .then(() => {
          // 计算总宽度
          let totalWidth = 0;
          slides.forEach((img) => {
            totalWidth += img.offsetWidth;
          });
          slide.style.width = `${totalWidth}px`;

          // 轮播逻辑
          let currentIndex = 0;
          let intervalId;

          const goToSlide = (index) => {
            currentIndex = index;

            // 新增文字同步代码（开始）
            const textItems = document.querySelectorAll(
              ".xiaoguo1, .xiaoguo2, .xiaoguo3, .xiaoguo4"
            );
            textItems.forEach((item, i) => {
              item.style.opacity = i === index ? "1" : "0";
            });
            // 新增文字同步代码（结束）

            let translateX = 0;
            for (let i = 0; i < index; i++) {
              translateX -= slides[i].offsetWidth;
            }
            slide.style.transform = `translateX(${translateX}px)`;

            // 更新指示器
            indicators.forEach((indicator, i) => {
              indicator.classList.toggle("active", i === currentIndex);
            });
          };

          // 自动轮播
          const startCarousel = () => {
            intervalId = setInterval(() => {
              goToSlide((currentIndex + 1) % slides.length);
            }, 3000);
          };

          // 重置计时器
          const resetInterval = () => {
            clearInterval(intervalId);
            startCarousel();
          };

          // 绑定指示器事件（修改部分）
          indicators.forEach((indicator, index) => {
            indicator.addEventListener("click", () => {
              goToSlide(index);
              resetInterval();
            });
          });

          // 启动轮播
          startCarousel();

          // 窗口大小变化时重新计算
          window.addEventListener("resize", () => {
            let newTotalWidth = 0;
            slides.forEach((img) => {
              newTotalWidth += img.offsetWidth;
            });
            slide.style.width = `${newTotalWidth}px`;
            goToSlide(currentIndex);
          });
        })
        .catch((err) => {
          console.error("轮播图初始化失败:", err);
        });
    },
    goToSlide(index) {
      console.log("goToSlide 方法被调用，index:", index);
      this.currentIndex = index;
      const slide = document.querySelector(".carousel-slide");
      if (!slide) {
        console.error("未找到 .carousel-slide 元素");
        return;
      }
      const slides = slide.children;
      if (slides.length === 0) {
        console.error("未找到轮播图子元素");
        return;
      }
      let translateX = 0;
      for (let i = 0; i < index; i++) {
        translateX -= slides[i].offsetWidth;
      }
      slide.style.transform = `translateX(${translateX}px)`;

      // 更新文字内容的显示状态
      const textItems = document.querySelectorAll(
        ".xiaoguo1, .xiaoguo2, .xiaoguo3, .xiaoguo4"
      );
      textItems.forEach((item, i) => {
        item.style.opacity = i === index ? "1" : "0";
      });

      // 更新指示器的状态
      const indicators = document.querySelectorAll(".indicator");
      indicators.forEach((indicator, i) => {
        indicator.classList.toggle("active", i === index);
      });
    },
    beforeDestroy() {
      clearInterval(this.intervalId);
    },
    changeIt1(a) {
      this.isActive1 = !this.isActive1;
      if (this.isActive1 == false) {
        this.isActive2 = true;
        this.isActive3 = true;
      }
    },
    changeIt2(a) {
      this.isActive2 = !this.isActive2;
      if (this.isActive2 == false) {
        this.isActive1 = true;
        this.isActive3 = true;
      }
    },
    changeIt3(a) {
      this.isActive3 = !this.isActive3;
      if (this.isActive3 == false) {
        this.isActive1 = true;
        this.isActive2 = true;
      }
    },
    gotolink() {
      this.$router.replace("/Work/list");
    },
    gotolink1() {
      this.$router.replace("/Work/list1");
    },
    gotolink2() {
      this.$router.replace("/Work/list2");
    },
    gotolink3() {
      this.$router.replace("/Work/list3");
    },
    onMoreWorks() {
      this.goWorkList();
    },
    goWorkList() {
      this.$router.push({
        path: "Work/list",
        query: {},
      });
    },
    goWork() {
      this.$router.push({
        path: "Work",
        query: {},
      });
    },
    goRoute(index) {
      this.$router.push({
        path: "/match",
        query: {
          pos: index,
        },
      });
    },
    getNewsList() {
      getNewsList({
        pageNum: 1,
        pageSize: 4,
      }).then((res) => {
        const { total, rows = [] } = res.data;
        this.hotList = rows;
      });
    },
    onSelect(activeIndex) {
      this.activeIndex = activeIndex;
    },

    onDown() {
      // 8 展示8个
      const y = (this.timeline.length - 8) * 60;
      if (Math.abs(this.translateY) >= y) return;
      this.translateY -= 60;
    },

    onUp() {
      if (this.translateY >= 0) return;
      this.translateY += 60;
    },

    gotoWorks() {
      this.$router.push({
        path: "/Work/list",
      });
    },

    onMore() {
      const { href } = this.$router.resolve({
        path: "/Export",
      });
      window.open(href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
// .beijigban {
//   height: 100%;
//   background:url("../../assets/image/beijinban.png") no-repeat center;
//   max-width: 1440px;
//   margin: -350px auto 0;
// }

//

#blink {
  visibility: visible;
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 保持图片比例并填满容器 */
}

.you {
  position: absolute;
  top: 53.1%;
  /* 垂直居中 */
  right: -12.7%;
  /* 调整这个值可以改变水平位置，值越小越靠左 */
  transform: translate(-50%, -50%);
  /* 精确居中 */
  max-width: 40%;
  /* 覆盖图的宽度 */
  max-height: 100%;
  /* 覆盖图的高度 */
}

.text-overlay {
  position: absolute;
  top: 52.5%;
  /* 垂直居中 */
  left: 25.4%;
  /* 调整这个值可以改变水平位置，值越小越靠左 */
  transform: translate(-50%, -50%);
  /* 精确居中 */
  max-width: 40%;
  /* 覆盖图的宽度 */
  max-height: 40%;
  /* 覆盖图的高度 */
}

.homePage {
  // height: 100%;
  // width: 1677px;
  .bannerBgc {
    position: relative;
    width: 100%;
    overflow: hidden;
    /* 防止内容溢出 */
  }

  .bannerBgc img {
    width: 100%;
    /* 关键：使图片宽度充满容器 */
    height: auto;
    /* 保持宽高比 */
    display: block;
    /* 避免图片下方有间隙 */
  }

  .banner_bootom {
    background-color: rgb(249, 246, 237);
    width: 100%;
    height: 180px;
    margin-top: -50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    padding-top: 50px;
  }

  .coloechange {
    width: 60%;
    margin: 0 auto;
    text-align: left;

    .cont {
      width: 100%;
      display: flex;

      .name {
        padding: 10px 0;
        width: 45%;
        text-align: right;
        margin-right: 65px;
        color: #c0c0c0;
        letter-spacing: 5px;
        font-size: 14px;
      }

      .linebox {
        padding: 10px 0;
        width: 38%;
        display: flex;
        justify-content: flex-end;

        .line {
          background-color: rgb(37, 135, 125);
          width: 95%;
          height: 15px;
          //margin-left: 80vw;
        }
      }
    }
  }

  .announcement {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    // padding: 50px 0 30px;
    background-color: 253, 253, 253;
    margin-top: -100px;

    .fuwufangweu {
      height: 700px;
    }

    .introduce {
      .content {
        display: flex;
        justify-content: center;
        height: 300px;

        .left-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 600px;
          padding: 20px;
          background-color: #fff;

          .top-info {
            line-height: 30px;
            font-size: 16px;
            text-align: left;
          }

          .bottom-btn {
            width: 100px;
            height: 30px;
            line-height: 30px;
            margin-top: 15px;
            border-radius: 15px;
            text-align: center;
            background-color: #5296d1;
            color: #fff;
          }
        }

        .right-content {
          width: 100%;
          height: 100%;
          // background-image: url("../../assets/other/bolang.png");
          align-items: center;

          .img1 {
            justify-content: center;
            width: 100%;
            height: 100%;
            width: 100%;
            object-fit: cover;
            /* 保持比例覆盖整个容器 */
            transition: transform 0.3s ease;
            /* 添加平滑过渡效果 */
          }
        }
      }
    }

    .product {
      margin-top: 1%;
      padding: 20px 200px;
      width: 100%;
      // margin: 0 auto;
      align-items: center;
      background-color: #fff;

      img {
        height: 130%;
        object-fit: contain;
      }

      .title {
        // margin-bottom: -111px;
        font-size: 44px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 55.5px;
        color: rgba(46, 49, 51, 1);
        text-align: center;
        vertical-align: top;
      }

      .top-search {
        position: relative;
        text-align: right;

        input {
          width: 250px;
          padding: 10px;
          border: none;
          outline: none;
          background-color: #f1f5fe;
        }

        .icon {
          position: absolute;
          top: 0px;
          right: 0;
          width: 35px;
          height: 35px;
          background: #5296d1;
          cursor: pointer;
        }
      }

      .bottom-info {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        height: 300px;

        .center-info {
          .center-img {
            height: 100%;
            margin: 0 5px;
            width: 240px;
            border: 2px solid #5296d1;

            .img {
              width: 150px;
              height: 100px;
              margin: 28px auto;
            }

            .txt {
              position: relative;
              width: 100%;
              height: 90px;
              line-height: 24px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
              margin-top: 78px;
            }

            .tab {
              display: flex;
              position: absolute;
              left: 90px;
              bottom: 0;

              .left {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background-color: #fff;
                color: #000;
                font-family: 仿宋;
              }

              .right {
                width: 30px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                background-color: #3b709f;
                color: #fff;
                font-family: 仿宋;
              }
            }
          }

          .center-img1 {
            box-shadow: #5296d1 0px 0px 18px inset;
            height: 100%;
            margin: 0 5px;
            width: 240px;
            border: 2px solid #5296d1;

            .img {
              width: 150px;
              height: 100px;
              margin: 28px auto;
            }

            .txt {
              position: relative;
              width: 100%;
              height: 90px;
              line-height: 24px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
              margin-top: 78px;
            }
          }
        }

        .right-info {
          height: 100%;
          margin: 0 5px;

          .top-img {
            border: 2px solid #5296d1;
            width: 240px;

            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
            }

            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }

          .bottom-img {
            border: 2px solid #5296d1;
            width: 240px;
            margin-top: 10px;

            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
            }

            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }

          .top-img1 {
            box-shadow: #5296d1 0px 0px 18px inset;
            border: 2px solid #5296d1;
            width: 240px;

            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
            }

            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }

          .bottom-img1 {
            box-shadow: #5296d1 0px 0px 18px inset;
            border: 2px solid #5296d1;
            width: 240px;
            margin-top: 10px;

            .img > img {
              width: 80px;
              height: 50px;
              margin: 10px auto;
            }

            .txt {
              width: 100%;
              height: 70px;
              padding-top: 10px;
              background-color: #5296d1;
              color: #fff;
            }
          }
        }

        .info-item {
          height: 100%;
          margin: 0 5px;

          .product-center {
            position: relative;
            width: 280px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: #5197d5;
            color: #fff;
            font-weight: bold;

            .icon1 {
              display: inline-block;
              position: absolute;
              top: 16px;
              left: 30px;
              width: 3px;
              height: 16px;
              background-color: #fff;
            }
          }

          .type1 {
            position: relative;
            width: 280px;
            height: 50px;
            line-height: 50px;
            margin-top: 10px;
            text-align: center;
            background-color: #b1dcff;
            color: #fff;
            font-weight: bold;

            .icon2 {
              display: inline-block;
              position: absolute;
              top: 20px;
              left: 24px;
              width: 16px;
              height: 3px;
              background-color: #fff;
            }
          }

          .type2 {
            position: relative;
            width: 280px;
            height: 50px;
            line-height: 50px;
            margin-top: 10px;
            text-align: center;
            background-color: #5197d5;
            font-weight: bold;

            .icon2 {
              display: inline-block;
              position: absolute;
              top: 20px;
              left: 24px;
              width: 16px;
              height: 3px;
              background-color: #fff;
            }
          }

          .more {
            position: relative;
            width: 280px;
            height: 40px;
            line-height: 40px;
            margin-top: 20px;
            text-align: center;
            background-color: #3c6fa0;
            color: #fff;
            font-weight: bold;

            .type3 {
              position: absolute;
              top: 0;
              right: 0;
              width: 40px;
              height: 40px;
              background-color: #5096d4;
              font-family: 仿宋;
            }
          }
        }
      }
    }

    .service {
      margin-top: 1%;

      .title {
        margin-top: 8px;
        font-size: 44px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 55.5px;
        color: rgba(46, 49, 51, 1);
        text-align: center;
        vertical-align: top;
        margin-bottom: -120px;
      }

      .service-info {
        width: 100%;
        display: flex;
        justify-content: center;
        height: 522px;
        padding: 20px 200px;
        margin-top: -1009px;

        .item {
          position: relative;

          .img {
            position: absolute;
            top: -35px;
            left: 50%;
            transform: translate(-50%);
            width: 70px;
            height: 70px;
            background-color: #5395d0;
            border-radius: 50%;
          }

          .text {
            width: 300px;
            padding: 50px 20px;
            line-height: 25px;
            background-color: #fff;
            text-align: left;
            font-size: 16px;

            .tip {
              margin-bottom: 10px;
              text-align: center;
              font-size: 20px;
              font-weight: bold;
              color: #5096d4;
            }

            .top-info {
              line-height: 30px;
              font-size: 16px;
              text-align: left;
            }
          }
        }
      }
    }

    .announcement_content {
      display: flex;
      // align-items: center;
      justify-content: center;
      padding-top: 40px;

      .announcement_text {
        width: 540px;
        height: 400px;
        margin-left: 60px;

        .button {
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          text-align: right;
        }

        .button:hover {
          color: #25877d;
        }

        .texts {
          cursor: pointer;
          width: 268px;
          height: 188px;
          overflow: hidden;
          border: 1px solid rgb(221, 221, 221);

          &:nth-child(2n + 2) {
            border-left: none;
          }

          &:nth-child(1),
          &:nth-child(2) {
            border-bottom: none;
          }
        }
      }
    }

    .news-box {
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-between;
    }
  }

  .announcement_video {
    width: 600px;
    height: 380px;
    cursor: pointer;
  }

  .judges {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 10px;

    .right {
      // margin-left: 400px;
      display: flex;

      // justify-content: space-around;
      // align-items: center;
      .right_img {
        margin-left: -100px;
        width: 324px;
        height: 350px;
      }

      .right_text {
        position: relative;
        width: 440px;
        margin-left: 56px;
        text-align: left;

        .semi {
          display: block;
          background: url("../../assets/image/yin.png") no-repeat right center;
          width: 45px;
          height: 45px;
        }

        .detail {
          margin-top: 50px;
          line-height: 22px;
          height: 140px;
          text-indent: 24px;
        }

        .more-btn {
          position: absolute;
          left: 0;
          bottom: 0;
          line-height: 30px;
          text-align: right;
          width: 100%;
        }
      }
    }

    .left {
      background-color: rgb(249, 246, 237);
      padding: 70px 200px 0 50px;
      height: 550px;
      box-sizing: border-box;

      .left_name {
        display: block;
        padding: 20px 0;
        line-height: 20px;
        padding-left: 50px;
        position: relative;

        &::before {
          content: "";
          width: 14px;
          height: 2px;
          overflow: hidden;
          background-color: #c7ad88;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          transition: all 0.25s;
        }
      }

      .left_name.selected {
        color: #25877d;

        &::before {
          background-color: #25877d;
          width: 30px;
        }
      }
    }
  }

  .good {
    display: flex;
    justify-content: center;
    align-items: center;

    .good_left {
      width: 810px;
      height: 668px;
    }

    .work-time-line {
      width: 562px;
      height: 100%;
      margin: auto;
      position: relative;

      // background: url('../../assets/image/index/work-logo.png') no-repeat center center;
      .times {
        position: absolute;
        font-size: 18px;
        line-height: 22px;
        transform: translate(-14px, 20px);

        &:hover,
        &.actived {
          color: #25877d;
        }
      }

      .times1 {
        top: 60px;
        left: 242px;
        color: #25877d;
      }

      .times2 {
        top: 120px;
        left: 358px;
      }

      .times3 {
        top: 180px;
        left: 422px;
      }

      .times4 {
        top: 240px;
        left: 442px;
      }

      .times5 {
        top: 300px;
        left: 442px;
      }

      .times6 {
        top: 360px;
        left: 442px;
      }

      .times7 {
        top: 440px;
        left: 422px;
      }

      .times8 {
        top: 500px;
        left: 352px;
      }

      .times9 {
        top: 550px;
        left: 242px;
      }

      .times10 {
        top: 500px;
        left: 120px;
      }

      .times11 {
        top: 440px;
        left: 80px;
      }

      .times12 {
        top: 360px;
        left: 60px;
      }

      .times13 {
        top: 300px;
        left: 60px;
      }

      .times14 {
        top: 240px;
        left: 60px;
      }

      .times15 {
        top: 180px;
        left: 60px;
      }

      .times16 {
        top: 120px;
        left: 60px;
      }

      .times17 {
        top: 60px;
        left: 60px;
      }
    }

    .good_right {
      // height: 600px;
      margin-left: 20px;
      text-align: right;

      .more-btn {
        line-height: 20px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }

    .works-img-box {
      display: flex;
      height: 600px;
      margin-top: 100px;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .works-img {
        width: 395px;
      }
    }
  }
}

.left-name-list {
  .icon {
    display: block;
    font-size: 0;
    background-position: center center;
    width: 100%;
    height: 16px;
    background-repeat: no-repeat;
    background-image: url("../../assets/image/index/up.png");
  }

  .icon.down {
    background-image: url("../../assets/image/index/down.png");
  }
}

.scroll-list-box {
  height: 360px;
  overflow: hidden;
  position: relative;
  margin: 5px 0;

  .scroll-list {
    transition: all 0.25s;
  }
}

.img-title {
  text-align: center;
}

.index-img-icon {
  cursor: pointer;
}

.works-box {
  background: url("../../assets/image/works-bg.jpg") no-repeat center top;
}

.works-main {
  height: 1064px;
  background: url("../../assets/image/works-main.jpg") no-repeat center top;

  .left-name-list {
    width: 180px;
    padding-left: 270px;
    padding-top: 140px;

    .icon {
      display: block;
      font-size: 0;
      background-position: center center;
      width: 100%;
      height: 16px;
      background-repeat: no-repeat;
      background-image: url("../../assets/image/index/up.png");
    }

    .icon.down {
      background-image: url("../../assets/image/index/down.png");
    }
  }

  .scroll-list-box {
    height: 480px;
    overflow: hidden;
    position: relative;
    margin: 5px 0;

    .scroll-list {
      transition: all 0.25s;
    }
  }

  // works
  .left_name {
    display: block;
    padding: 20px 0;
    line-height: 20px;
    font-size: 15px;
    padding-left: 50px;
    position: relative;

    &::before {
      content: "";
      width: 22px;
      height: 4px;
      overflow: hidden;
      background-color: #c7ad88;
      border-radius: 4px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      transition: all 0.25s;
    }
  }

  .left_name.selected {
    color: #25877d;
    font-weight: 700;

    &::before {
      background-color: #25877d;
      width: 40px;
    }
  }
}

// .banner-text-box {
//   top: 130px;
// }

.s-text-box-1 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 19%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}

.s-text-box-2 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 33%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}

.s-text-box-3 {
  position: absolute;
  width: 32%;
  height: 28%;
  top: 20%;
  left: 57%;
  background: rgba(228, 76, 88, 0.9);
  color: #fff;
  font-size: 36px;
}

.saidao-text {
  padding-top: 60px;
}
</style>
<style lang="scss">
.carousel-box {
  // .el-carousel__container {height: auto;min-height: 300px;}
  .el-carousel__button {
    background: #c1c1c1;
  }

  .is-active .el-carousel__button {
    background: #25877d;
  }
}

.homePage {
  .footerbox {
    margin-top: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/homePage/homePage.vue